var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSetpointCwuCzuwanie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "27.6885mm",
    height: "41.385mm",
    viewBox: "0 0 3449.35 5155.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    fill: "#009245",
    d: "M3162.68 2481.53l-1432.09 -2481.53 -1404.36 2426.28c-204.36,283.29 -326.23,629.29 -326.23,1006.23 0,950.82 773.22,1723.11 1724,1723.11 953.06,0 1725.36,-772.29 1725.36,-1723.11 0,-351.01 -105.92,-678.38 -286.68,-950.98z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetpointCwuCzuwanie);
export default __webpack_public_path__ + "static/media/setpoint-CWU-czuwanie.40d7d8466348866e131dd71892df2c86.svg";
export { ForwardRef as ReactComponent };